module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents-box row"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t("service.tab2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t(("service." + _vm.txt1))))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-5 prodect-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b33b4164","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Service/smec.vue
// module id = 274
// module chunks = 1